import React from 'react';
import clsx from 'clsx';
import { Button } from '../../Elements';

export type SideDrawerProps = {
	children: React.ReactElement;
	isExpanded: boolean;
	containerClass: string;
	handleClick: () => void;
	name: string;
	openIcon: React.ReactElement;
	closeIcon: React.ReactElement;
	buttonClass: string;
	dataTestId?: string;
};

export const SideDrawer = (props: SideDrawerProps) => {
	const {
		children,
		isExpanded,
		containerClass = '',
		buttonClass = '',
		handleClick,
		name,
		openIcon,
		closeIcon,
		dataTestId = '',
	} = props;

	return (
		<aside
			className={clsx(
				'border-r-2 border-secondaryBorder transition-width transition-min-width ease-in-out delay-100 duration-300',
				containerClass
			)}
			data-test-id={dataTestId}
		>
			<Button
				variant='icon'
				size='icon'
				onClick={handleClick}
				aria-label='Collapsible'
				className={clsx('flex flex-row justify-center absolute', buttonClass)}
				title={`${isExpanded ? 'Hide' : 'Show'} ${name}`}
			>
				<>
					<span className='sr-only'>
						{isExpanded ? 'Close' : 'Open'} {name}
					</span>
					{isExpanded ? closeIcon : openIcon}
				</>
			</Button>
			{children}
		</aside>
	);
};
